import React from 'react';
import {CheckboxBlankCircle , CheckboxBlankCircleOutline} from 'mdi-material-ui';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

export default function SkillRate(props) {
    let temp = [1,2,3,4,5]
    return(
        <div style={{display:'flex',flexWrap:"wrap",alignItems:'center'}}>
            <div>
                <Typography component="div">
                    <Box fontSize={16} m={1} style={{width:180}}>
                        {props.label}
                    </Box>
                </Typography>
            </div>
            <div style={{display:'flex'}}>
                {
                    temp.map(item => (item<=props.rate?<CheckboxBlankCircle color="primary" style={{fontSize:20}} />:<CheckboxBlankCircleOutline color="primary" style={{fontSize:20}}/>))
                }
            </div>
        </div>
    )
}